import { Component, h, Prop, State } from '@stencil/core';
import { AppProduct, AppProductCondensed, AppSpecificationsMatrix } from '../../functional';
import { getProductSpecs } from '../../shared/api'
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import pick from 'lodash/pick';
import state from '.././../store/store'

@Component({
    tag: 'section-products'
})
export class SectionProducts {

    @Prop() __component: string;
    @Prop() data: any = {};

    @State() ShowCompare: boolean = false;
    @State() Compared: Array<number> = [];
    @State() specs: any = {};
    @State() search: string = '';

    BarcodeDetector: boolean = false;

    async componentWillLoad() {
        this.BarcodeDetector = state.browser['BarcodeDetector'];
    }

    handleDetected(ev) {
        if (!ev.detail) return;
        const router: any = state.Router;
        router.push(ev.detail);
    }

    async getProductSpecs(id) {
        if (!this.specs[id]) {
            const specs = await getProductSpecs(id);
            this.specs[id] = {};
            this.specs[id].Title = get(specs, 'data.data.attributes.Title')
            this.specs[id].Specifications = get(specs, 'data.data.attributes.Specification.Specifications')
        }
    }

    onToggleShowCompare() {
        this.ShowCompare = !this.ShowCompare;
    }

    onSearch(ev) {
        const search: any = ev.target.value;
        const btnSearch = document.getElementById('section-products-search');
        const btnClear = document.getElementById('section-products-search-clear');
        this.search = search.toLowerCase();
        if (search) {
            setTimeout(() => btnClear.click(), 1);
            setTimeout(() => btnSearch.click(), 50);
        } else {
            setTimeout(() => btnClear.click(), 1);
        }
    }

    async onToggleCompare(id) {
        if (this.Compared.includes(id)) {
            this.Compared = this.Compared.filter((f) => id != f)
        }
        else {
            await this.getProductSpecs(id)
            this.Compared = [...this.Compared, id]
        }
    }

    getCTA(Page, OwnerPage) {
        if (this.data.OwnerLink) {
            return {
                Label: get(state, 'website.ProductOwnerCTA') || 'View', URL: ('/' + get(OwnerPage, 'data.attributes.Slug')) || ('/owners/' + get(Page, 'data.attributes.Slug'))
            }
        }
        else {
            return { Label: get(state, 'website.ProductsCTA'), URL: get(Page, 'data.attributes.Slug') }
        }
    }

    render() {
        const { Title, Description, EnableComparison, products, Filters, EnableSearch, SearchPlaceholder, RemoveTopMargin = false } = this.data;

        if (!products) return;

        const productList = get(products, 'data') || [];

        const viewPortEnableComparison = EnableComparison && get(state, 'browser.mediaSize') !== 's'

        // Construct filter options
        const sortedFilters = sortBy(Filters.data, ['attributes.Group', 'attributes.Label'])
        const groups = sortedFilters.map(item => item.attributes.Group).filter((value, index, self) => self.indexOf(value) === index);
        const HideTitle = !Title;

        return (
            <section class={`uk-inline uk-width-1-1 uk-section uk-margin-medium-top ${(HideTitle || RemoveTopMargin) ? 'uk-padding-remove-top' : ''}`}>
                <div hidden={!viewPortEnableComparison} uk-sticky="end: true" class="uk-text-right" style={{ 'height': '0' }}>
                    <button hidden={this.ShowCompare && this.Compared && this.Compared.length > 0} onClick={this.onToggleShowCompare.bind(this)} class="wsio-vertical-right uk-button uk-button-secondary"><div class="uk-flex uk-flex-middle">Compare <span class="uk-margin-small-left" uk-icon="settings"></span></div></button>
                    <a hidden={this.Compared.length == 0} href="#AppSpecificationsMatrix" class="wsio-vertical-right uk-button uk-button-secondary" uk-scroll>{`View Comparison (${this.Compared.length})`}</a>
                </div>
                <div class="uk-container uk-container-large">
                    <div class="uk-text-center" hidden={HideTitle}>
                        <h2 class="uk-heading-xlarge wsio-darker-green">
                            {Title}
                        </h2>
                        <p hidden={!Description} class="uk-container wsio-dark-grey uk-text-lead">
                            {Description}
                        </p>
                    </div>
                    <div class="uk-padding" uk-filter="target: .js-filter">
                        {
                            [
                                // Filters
                                groups && groups.length > 0 && <div class="uk-flex-center uk-text-center uk-grid-small uk-grid-divider uk-child-width-auto" uk-grid>
                                    <div>
                                        <ul class="uk-subnav uk-flex-center uk-subnav-pill" uk-margin>
                                            <li class="uk-active" uk-filter-control><a href="#" rel="nofollow" >All</a></li>
                                        </ul>
                                    </div>
                                    {
                                        groups.map((group) =>
                                            <div>
                                                <ul class="uk-subnav uk-flex-center uk-subnav-pill" uk-margin>
                                                    {
                                                        sortedFilters
                                                            .filter(({ attributes }) => attributes.Group == group)
                                                            .map(
                                                                ({ attributes: { Label } }) => <li uk-filter-control={`filter: [data-${group}*='${Label}']; group: data-${group}`}><a href="#" rel="nofollow" >{Label}</a></li>
                                                            )
                                                    }
                                                </ul>
                                            </div>
                                        )
                                    }
                                </div>,
                                // Search
                                <div hidden={!EnableSearch} class="uk-margin uk-flex-middle uk-flex-center uk-flex@s">

                                    <form onSubmit={(ev) => ev.preventDefault()} class="uk-width-1-1 uk-search uk-search-default uk-flex-1">
                                        <span class="uk-search-icon-flip" uk-search-icon></span>
                                        <input onInput={this.onSearch.bind(this)} name='search' class="uk-search-input" type="search" placeholder={SearchPlaceholder || 'Search'} />
                                    </form>
                                    <div class="uk-text-meta uk-margin-right uk-margin-small-top"></div>
                                    <div hidden={!this.BarcodeDetector} class="">
                                        <app-qr onDetected={ev => this.handleDetected(ev)}><a class="uk-button uk-button-secondary uk-flex uk-flex-middle" href="#qr-modal" uk-toggle>Scan QR <span class="uk-margin-small-left" uk-icon="thumbnails"></span></a></app-qr>
                                    </div>

                                    <div uk-filter-control><a id='section-products-search-clear' aria-label="clear search" href="#" rel="nofollow" ></a></div>
                                    <div uk-filter-control={`filter: [data-title*='${this.search}']; group: data-title`} ><a id='section-products-search' aria-label="apply search" href="#" rel="nofollow" ></a></div>
                                </div>
                            ]
                        }
                        <div>
                            {
                                this.data.OwnerLink ?
                                    <div class="js-filter uk-child-width-1-1 uk-child-width-1-2@m uk-margin-large-top uk-grid-match" uk-grid>
                                        {productList.map(({ attributes, id }, i) => {
                                            const { Title, Description, Image, Tags, Page, OwnerPage } = attributes
                                            return <AppProductCondensed Title={Title} Description={Description} Image={Image} Tags={Tags} CTA={this.getCTA(Page, OwnerPage)} ShowCompare={this.ShowCompare} IsCompare={this.Compared.includes(id)} OnCompare={this.onToggleCompare.bind(this, id)} Eager={i <= 4} />
                                        })
                                        }
                                    </div>
                                    :
                                    <div class="js-filter uk-flex-center uk-text-center uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l uk-margin-top uk-grid-match" uk-grid>
                                        {productList.map(({ attributes, id }, i) => {
                                            const { Title, Description, Image, Tags, Page, OwnerPage } = attributes
                                            return <AppProduct Title={Title} Description={Description} Image={Image} Tags={Tags} CTA={this.getCTA(Page, OwnerPage)} ShowCompare={this.ShowCompare} IsCompare={this.Compared.includes(id)} OnCompare={this.onToggleCompare.bind(this, id)} Eager={i <= 4} />
                                        })
                                        }
                                    </div>
                            }
                        </div>
                        <div hidden={!this.Compared || this.Compared.length == 0} id="AppSpecificationsMatrix" class="uk-margin-large-top">
                            {
                                this.ShowCompare && this.Compared && this.Compared.length > 0 &&
                                <div>
                                    <h2 class="uk-margin-top uk-heading-large wsio-darker-green">Comparison Sheet</h2>
                                    {this.Compared.map((machine) => <a class="uk-badge uk-badge-gold" onClick={this.onToggleCompare.bind(this, machine)}><span class="uk-margin-small-right" uk-icon="close"></span>{this.specs[machine].Title}</a>)}
                                    <AppSpecificationsMatrix Specifications={pick(this.specs, this.Compared)} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}